export default __webpack_public_path__ + "assets/ico-minimize-b9e27029.svg";